import slugify from "slugify";

const analysisGetter = async (url) => {
    try {
        const r = await fetch(url)
        if (!r.ok) {
            throw new Error(`Response status: ${r.status}`)
        }
        const d = await r.json();
        return d
    } catch(error) {
        console.error(error)
    }
}

// ! rename the function to align with the widget name
export const sonataDetailedComparisons = async () => {
    const el = document.querySelector('.curious-sonata-detailed-comparisons');
    if (!el) return;
    // ------------------------------------------------------------
    const endpoint = el.getAttribute('data-endpoint');
    if (!endpoint) {
        console.error('No endpoint specified for the sonata-variant-analysis-table widget');
        return;
    }
    const url = `${window.apiUri}${endpoint}/meta`
    try {
        const response = await fetch(url)
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`)
        }
        const data = await response.json();
        const checked = []
        const html = Object.keys(data).map((collection, i) => {
            let currentCollection = collection
            checked.push(collection)
            if(i < Object.keys(data).length - 1) {
            return `
                <div class="toggle">
                    <div class="header">
                        <div>
                            <h3>${collection}</h3>
                            <div class="curious-widget curious-simple-button">
                                <a class="button secondary"  href="/collection/${slugify(collection, {strict: true})}">
                                    <span>See the collection</span>
                                </a>
                            </div>
                        </div>

                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 11.4286H11.4286V20H8.57143V11.4286H0V8.57143H8.57143V0H11.4286V8.57143H20V11.4286Z" fill="black"/>
                        </svg>
                    </div>
                    <div class="body">
                        <div class="toggle-inner">
                            ${
                                Object.keys(data).map(c => {
                                    if (c !== currentCollection && !checked.includes(c)) {
                                        return `
                                        <div class="nested-toggle" data-endpoint="${window.apiUri}${endpoint}/compare/${slugify(collection.toLowerCase(), {strict: true})}/${slugify(c.toLowerCase(), {strict: true})}" data-loaded="not-loaded">
                                            <div class="nested-header">
                                                <h4>${c}</h4>
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M20 11.4286H11.4286V20H8.57143V11.4286H0V8.57143H8.57143V0H11.4286V8.57143H20V11.4286Z" fill="black"/>
                                                </svg>
                                            </div>
                                            <div class="nested-body">
                                                <div class="nested-toggle-inner">
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        
                                        `
                                    }
                                }).join('')
                            }
                        </div>
                    </div>
                </div>
                `
            } else {
                return ''
            }
        }).join('')
        

        const toggleContainer = el.querySelector('.toggle-container')
        toggleContainer.innerHTML = html
        
       
    } catch(error) {
        el.style.display = 'none';
        let to_hide = document.querySelectorAll('.curious-sonata-detailed-comparisons.loading, .needs_data');

        to_hide.forEach(element => {
            element.style.display = 'none';
        });
        console.warn(`Failed to fetch ${url}: ${error} - hiding detailed comparisons`);
    }

    const toggles = el.querySelectorAll('.toggle');

    if(!toggles) {
        el.style.display = 'none';
        let to_hide = document.querySelectorAll('.curious-sonata-detailed-comparisons.loading, .needs_data');

        to_hide.forEach(element => {
            element.style.display = 'none';
        });
        console.warn(`Failed to fetch ${url}: ${error} - hiding detailed comparisons`);
        return;
    }
    toggles.forEach(toggle => {
        const mainheader = toggle.querySelector('.header');
        const mainbody = toggle.querySelector('.body');
        mainheader.addEventListener('click', () => {
            if (toggle.classList.contains('active')) {
                toggle.classList.remove('active');
                mainbody.style.maxHeight = 0;
            } else {
                toggle.classList.add('active');
                mainbody.style.maxHeight = mainbody.scrollHeight + "px";
            }
        })
        const nestedToggles = toggle.querySelectorAll('.nested-toggle')
        nestedToggles.forEach( (nestedToggle) => {
            const nestedheader = nestedToggle.querySelector('.nested-header')
            const nestedbody = nestedToggle.querySelector('.nested-body')
            const nestedInner = nestedToggle.querySelector('.nested-toggle-inner')
            nestedheader.addEventListener('click', () => {
                if(nestedToggle.getAttribute('data-loaded') === 'not-loaded') {
                    const subEndpoint = nestedToggle.getAttribute('data-endpoint')
                    const content = analysisGetter(subEndpoint).then((analysis) => {
                        return analysis
                    }).then((info) => {
                        console.log(info.complete_matches.length)
                        nestedInner.innerHTML = `    
                            <div class="analysis-container">
                                ${(info.complete_matches.length !== 0) ? `
                                    <h5>Complete Matches</h5>
                                    <div class="complete-matches">
                                        ${Object.keys(info.complete_matches).map(bar => (
                                            `
                                            <div class="match">

                                                <h6>Bar ${bar}</h6>
                                                <span class="value">${info.complete_matches[bar]}</span>
                                            
                                            </div>
                                            `
                                        )).join('')}
                                    </div>  
                                ` : ''}
                                
                                ${(info.partial_matches.length !== 0) ? `
                                    <h5>Partial Matches</h5>
                                    <div class="partial-matches">
                                        ${Object.keys(info.partial_matches).map(bar => (`
                                            <div class="match">
                                            <h6>Bar ${bar}</h6>
                                            ${Object.keys(info.partial_matches[bar]).map(comparison => (`
                                                <div class="collection-grouping">
                                                    <span class="collection">${comparison}: </span>
                                                    <span class="value">${info.partial_matches[bar][comparison]}</span>
                                                </div>
                                            `)).join('')}
                                            </div>
                                        `)).join('')}
                                    </div>
                                ` : ''}
                                
                            </div>

                        `
                        
                    }).then(() => {
                        mainbody.style.maxHeight = mainbody.scrollHeight + nestedbody.scrollHeight + "px"
                        nestedbody.style.maxHeight = nestedbody.scrollHeight + "px";
                    })


                    nestedToggle.setAttribute('data-loaded', 'loaded')
                }

                if (nestedToggle.classList.contains('active')) {
                    nestedToggle.classList.remove('active');
                    nestedbody.style.maxHeight = 0;
                } else {
                    nestedToggle.classList.add('active');
                    nestedbody.style.maxHeight = nestedbody.scrollHeight + "px";
                    mainbody.style.maxHeight = mainbody.scrollHeight + nestedbody.scrollHeight + "px"
                }
                
            })
        })
        el.classList.remove('loading');
    })

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

